import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import InputMask from "react-input-mask";

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";
import Util from "../../../actions/util";
import DataUtil from "../../../actions/data.js";

import ConsultaAtendimentoResultado from "./ConsultaAtendimentoResultado";

class ConsultaAtendimento extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consulta: {
        periodoDe: DataUtil.primeiroDiaMes(),
        periodoAte: DataUtil.hoje(),
        profissionalId: this.props.usuario.perfil < 2 ? 0 : this.props.usuario.id,
        paciente: ""
      },
      usuarios: [],
      resultado: []
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.excluir = this.excluir.bind(this);
    this.duplicar = this.duplicar.bind(this);
  }

  componentWillMount() {
    UI.loader("show", "Aguarde, buscando profissionais...");
    API.get("/usuarios/ativos").then(
      (json) => {
        // Cria uma lista simplificada de usuários
        let usuarios = [{ id: 0, nome: "TODOS" }];
        json.data.forEach(usuario => {
          usuarios.push({
            id: usuario.id,
            nome: usuario.nome
          });
        });
        this.setState({ usuarios: usuarios });
        UI.loader("hide");
      });
  }

  handleSubmit(event) {
    event.preventDefault();

    let data = this.state.consulta;
    if (!DataUtil.validarData(data.periodoDe)) {
      data.periodoDe = DataUtil.primeiroDiaMes();
    }
    if (!DataUtil.validarData(data.periodoAte)) {
      data.periodoAte = DataUtil.hoje();
    }

    UI.loader("show", "Um momento...");
    API.post("/atendimentos/consulta", data)
      .then(
        function (json) {
          this.setState({ resultado: json.data });
          UI.loader("hide");
        }.bind(this)
      )
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  }

  handleChange(event) {
    let consulta = this.state.consulta;
    consulta[event.target.name] = event.target.value;

    this.setState({ consulta: consulta });
  }

  exportarCSV() {
    if (!Util.exportarAtendimentosCSV(this.state.resultado)) {
      UI.alert(false, "Não há nenhum resultado para ser exportado.");
    }
  }

  excluir(atendimento, index) {
    UI.confirm("Atenção", "Tem certeza que deseja excluir o atendimento #" + atendimento.id + "?").then((confirma) => {
      if (confirma) {
        UI.loader("show", "Um momento...");
        API.delete("/atendimentos/" + atendimento.id)
          .then(
            (json) => {
              UI.alert(json.success, json.message);
              if (json.success) {
                let resultado = this.state.resultado.filter((value, i, arr) => { return i !== index; });
                this.setState({ resultado: resultado });
              }
              UI.loader("hide");
            }
          )
          .catch(
            (json) => {
              UI.alert(false, json.message);
              UI.loader("hide");
            });
      }
    });
  }

  duplicar(atendimento, index) {
    UI.confirm("Atenção", "Tem certeza que deseja duplicar o atendimento #" + atendimento.id + "?").then((confirma) => {
      if (confirma) {
        UI.loader("show", "Um momento...");
        API.post("/atendimentos/" + atendimento.id + "/duplicar")
          .then(
            (json) => {
              UI.alert(json.success, json.message);
              if (json.success) {
                this.state.resultado.splice(index, 0, json.data);
                let resultado = this.state.resultado;
                this.setState({ resultado: resultado });
              }
              UI.loader("hide");
            }
          )
          .catch(
            (json) => {
              UI.alert(false, json.message);
              UI.loader("hide");
            });
      }
    });
  }

  render() {
    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <h4 className="card-title">CONSULTA ATENDIMENTO</h4>
                  </div>
                  <div className="col-md-6 text-right">
                    <button
                      onClick={() => { this.props.history.push("/atendimento/cadastro"); }}
                      className="btn btn-rounded btn-icons btn-outline-success"
                      type="button">
                      <i className="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <p className="card-description" />
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group row">
                      <div className="col-md-3">
                        <label>Período De</label>
                        <InputMask
                          placeholder="PERÍODO DE"
                          name="periodoDe"
                          className="form-control"
                          mask="99/99/9999"
                          value={this.state.consulta.periodoDe}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Período Até</label>
                        <InputMask
                          placeholder="PERÍODO ATÉ"
                          name="periodoAte"
                          className="form-control"
                          mask="99/99/9999"
                          value={this.state.consulta.periodoAte}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-sm-3">
                        <label>Profissional</label>
                        <select
                          name="profissionalId"
                          className="form-control"
                          value={this.state.consulta.profissionalId}
                          onChange={this.handleChange}
                        >
                          {this.state.usuarios.map(
                            (usuario, i) => {
                              if (this.props.usuario.perfil < 2 || this.props.usuario.id === usuario.id)
                              return (
                                <option key={usuario.id} value={usuario.id}>
                                  {usuario.nome}
                                </option>
                              );
                              else return false;
                            }
                          )}
                        </select>
                      </div>
                      <div className="col-sm-3">
                        <label>Paciente (ID ou Nome)</label>
                        <input
                          placeholder="PACIENTE"
                          name="paciente"
                          type="text"
                          className="form-control"
                          value={this.state.consulta.paciente}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 text-right">
                        <button
                          type="button"
                          className="btn btn-sm btn-success mb-2"
                          onClick={() => this.exportarCSV()}
                        >
                          <i className="fa fa-download"></i>&nbsp;
                            Exportar CSV
                        </button>
                        &nbsp;
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary mb-2"
                        >
                          <i className="fa fa-search"></i>&nbsp;
                            Pesquisar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <ConsultaAtendimentoResultado habilitarPagamento={false} resultado={this.state.resultado} onExcluir={this.excluir} onDuplicar={this.duplicar} />
              </div>
            </div>
          </div>
        </div>
      </form >
    );
  }
}

export default withRouter(ConsultaAtendimento);
